<template>
  <v-container fluid class="pb-15">
    <span v-for="category in categories" :key="category.name" :style="`width: ${50 * category.size}%;`">
      <v-row no-gutters class="mt-2">
        <v-col cols="12" class="pb-1">
          <v-card tile flat class="pl-2 mx-2" :color="category.color"
            ><span class="text-h6 font-weight-medium">{{ category.name }}</span></v-card
          >
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="my-5 mx-10">
        <v-row>
          <v-col :cols="12 / category.size" class="pt-0 pb-1" v-for="item in category.items" :key="item.name">
            <span v-if="item.type === 'blank'"></span>
            <BtnManualDownLoad
              v-if="category.isManualDownLoad"
              :icon="category.icon"
              :color="category.iconColor"
              :name="item.name"
              :filePath="item.filePath"
              @click="onClickMenu($event)"
            />
            <BtnTopMenu
              v-else
              :icon="category.icon"
              :color="category.iconColor"
              :name="item.name"
              :route="item.route"
              @click="onClickMenu($event)"
            />
          </v-col>
        </v-row>
      </v-row>
    </span>
  </v-container>
</template>

<script>
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import BtnTopMenu from '@/components/atoms/button/BtnTopMenu'
import BtnManualDownLoad from '@/components/atoms/button/BtnManualDownLoad'

export default {
  name: 'MenuPage',

  mixins: [APIUtils, Message, Loading],

  components: {
    BtnTopMenu,
    BtnManualDownLoad,
  },

  props: {
    _categories: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      categories: [],
    }
  },

  computed: {
    _categoriesComputed: {
      get() {
        return this._categories
      },
      set(value) {
        this.$emit('update:_categories', value)
      },
    },
  },

  watch: {
    _categoriesComputed(value) {
      if (value) {
        this.setMenu(value)
      }
    },
  },

  methods: {
    onClickMenu(item) {
      this.$router.push({ name: item.route }).catch(() => {})
    },
    setMenu(categories) {
      for (let category = categories.length - 1; category >= 0; category--) {
        if (!categories[category].isManualDownLoad) {
          for (let item = categories[category].items.length - 1; item >= 0; item--) {
            const func = this.$store.getters.allowedFunctions.find(
              ({ functionCd }) => functionCd == categories[category].items[item].functionCd,
            )
            if (!func) {
              // functionCdが存在していなければそのitemsの要素を削除
              categories[category].items.splice(item, 1)
            } else {
              // functionCdが存在していればnameを代入
              categories[category].items[item]['name'] = func.functionName
            }
          }
          if (categories[category].items.length == 0) {
            // itemsの中身が無ければそのカテゴリー要素を削除
            categories.splice(category, 1)
          }
        }
      }

      this.categories = categories
    },
  },
}
</script>
